import { Component, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { firstValueFrom, map, Observable, Subject, takeUntil } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserViewModel } from '../../../shared/interfaces/viewmodels/userviewmodel';
import { state } from '@angular/animations';
import { AccountState } from '../../../shared/store/state/account.state';
import { AccountActions } from '../../../shared/store/action/account.action';
import { AssignedSubApplications, IORD_Order, ORD_Order, PatchORDOrderDto, ReturnViewModel, RTAOptions } from '../../../shared/interfaces/request.interface';
import { GroupResult, groupBy } from "@progress/kendo-data-query";
import { OptionState } from '../../../shared/store/state/options.state';
import { handIcon, eyeIcon, SVGIcon } from "@progress/kendo-svg-icons";
import { DialItem } from '@progress/kendo-angular-buttons';
import { RequestActions } from '../../../shared/store/action/request.action';
import { GlobalNotificationService } from '../../../shared/services/globalnotification.service';
import { BasicDataComponent } from '../../../shared/components/basic-data/basic-data.component';
import { Router } from '@angular/router';
import { RequestState } from '../../../shared/store/state/request.state';


@Component({
    selector: 'app-create',
    templateUrl: './create.component.html',
    styleUrls: ['./create.component.css'],
    standalone: false
})

export class CreateComponent implements OnInit {
  private destroy$ = new Subject<void>();

  @ViewChildren(BasicDataComponent)
  private basicDataForms!: QueryList<BasicDataComponent>;
  public newRequest: IORD_Order = {} as IORD_Order;
  
  constructor(private fb: FormBuilder, private store: Store,
    private globalNotificationService: GlobalNotificationService,
    private router: Router) {
    
  }
  public user$!: Observable<UserViewModel>;

  public appBasicData!: FormGroup;

  async onSave(): Promise<void> {
    let allValid = true;
    this.basicDataForms.forEach(child => {
      if (!child.validateForm()) {
        allValid = false;
      }
    });
    if (!allValid) {
      return;
    }

    const initialRequestId = await firstValueFrom(
      this.store.select(RequestState.getRequest).pipe(
        map(request => request?.id ?? null)
      )
    );

    const user = await firstValueFrom(
      this.user$.pipe(
        filter((u): u is UserViewModel => !!u)
      )
    );

    try {
      await firstValueFrom(this.store.dispatch(new RequestActions.SaveDraft({ draftId: undefined, userId: user.id })));

      const createdRequest = await firstValueFrom(this.store.select(RequestState.getRequest));

      if (createdRequest?.id && createdRequest.id !== initialRequestId) {
        await this.router.navigate(['/edit', createdRequest.id]);
      }
    } catch (error) {
      // navigation suppressed when save fails
    }
    
  }
  public showRegion = false;
  public showToolSize = false;

  
  ngOnInit(): void {
    this.user$ = this.store.select(AccountState.user);
  }
}
